import React from 'react';
import './ShortcutHintList.less';

export interface IHint {
  keyValue: string;
  label: string;
  onClick: (e: React.MouseEvent) => void;
}

export interface IShortcutHintListProps {
  hints: IHint[];
}

export const ShortcutHintList = ({ hints }: IShortcutHintListProps) => (
  <div className="dp-shortcut-hint-list">
    {hints.map(({ keyValue, label, onClick }, index) => (
      <button key={index} className="dp-shortcut-hint-list__hint" onClick={onClick}>
        <div className="dp-shortcut-hint-list__hint-keyvalue">{keyValue}</div>
        <div className="dp-shortcut-hint-list__hint-label">{label}</div>
      </button>
    ))}
  </div>
);
